import React from 'react';
import ReactDOM from 'react-dom';
import './LoadingOverlay.css';

const LoadingOverlay = () => {
  return ReactDOM.createPortal(
    <div className="loading-overlay">
      <div className="overlay-spinner">
        <div className="spinner"></div>
        <p>Updating data ...</p>
      </div>
    </div>,
    document.body
  );
};

export default LoadingOverlay;
